import {CssBaseline, GlobalStyles} from '@mui/material';

export const AppGlobalStyles = (
    <>
        <CssBaseline />
        <GlobalStyles
            styles={theme => ({
                'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active':
                    {
                        WebkitBoxShadow: `0 0 0 30px ${theme.palette.grey[100]} inset !important`,
                        WebkitTextFillColor: `${theme.palette.text.primary} !important`,
                        caretColor: `${theme.palette.text.primary} !important`,
                    },
                'a.link': {
                    'color': theme.palette.primary.main,
                    'textDecoration': 'none',
                    'fontWeight': 500,
                    'transition': 'color 0.3s ease, border-color 0.3s ease',
                    'borderBottom': `2px solid transparent`,
                    '&:hover': {
                        color: theme.palette.secondary.main,
                        borderBottomColor: theme.palette.secondary.main,
                    },
                },
            })}
        />
    </>
);
